import { Paragraph } from "@digdir/designsystemet-react";

const defaultFormatNumber = (value: number) => {
    if (typeof value !== "number" || Number.isNaN(value)) {
        return "0,00";
    }

    return value.toLocaleString("nb-NO", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

interface TooltipItemProps {
    label: string;
    value: number;
    suffix?: string;
    unit?: string;
    formatValue?: (value: number) => string | number;
}

export const TooltipItem: React.FC<TooltipItemProps> = ({ label, value, suffix, unit = "", formatValue }) => {
    const unitLabel = unit.trim();
    const showUnit = unitLabel.length > 0;
    const formattedValue = formatValue ? formatValue(value) : defaultFormatNumber(value);
    const suffixText = suffix ? `${suffix}${showUnit ? ` ${unitLabel}` : ""}`.trim() : undefined;

    return (
        <Paragraph>
            <span
                style={{
                    display: "block",
                    color: "var(--ds-color-text-subtle)",
                    fontSize: "var(--ds-font-size-2)",
                }}
            >
                {label.toUpperCase()}
            </span>
            <span
                style={{
                    display: "block",
                    color: "var(--ds-color-text-default)",
                    fontSize: "var(--ds-font-size-4)",
                }}
            >
                {formattedValue}
                {showUnit && ` ${unitLabel}`}{" "}
                {suffixText && (
                    <span style={{ fontSize: "var(--ds-font-size-2)", color: "var(--ds-color-text-subtle)" }}>
                        ({suffixText})
                    </span>
                )}
            </span>
        </Paragraph>
    );
};
